/**
 * Revenue page — localization manifest.
 */
export const revenueManifest: readonly string[] = [
  "revenue.title",
  "revenue.totalMRR",
  "revenue.totalARR",
  "revenue.addRecord",
  "revenue.customer",
  "revenue.product",
  "revenue.plan",
  "revenue.period",
  "revenue.source",
  // Shared
  "nav.revenue",
  "common.loading",
  "common.noData",
  "common.search",
  "common.filter",
  "common.export",
  "common.actions",
  "common.status",
  "common.amount",
  "common.currency",
  "common.save",
  "common.cancel",
  "common.delete",
  "common.edit",
  "common.create",
] as const;
